import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IMetricDescriptionParams {
  id: string;
  description: string;
}

export class SetMetricDescriptionRequest extends Request<IMetricDescriptionParams, IResult> {
  constructor(params: IMetricDescriptionParams) {
    super('setMetricDescription', params);
  }
}
